// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.captions {
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 80%;
  padding: 12px 16px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  border-radius: 4px;
  font-size: 16px;
  line-height: 1.5;
  z-index: 1000;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

`, "",{"version":3,"sources":["webpack://./src/components/Captions.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C","sourcesContent":[".captions {\n  position: fixed;\n  bottom: 80px;\n  left: 50%;\n  transform: translateX(-50%);\n  max-width: 80%;\n  padding: 12px 16px;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  border-radius: 4px;\n  font-size: 16px;\n  line-height: 1.5;\n  z-index: 1000;\n  text-align: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
